import React from "react";
import { ReactComponent as ClockIcon } from "assets/icons/clock.svg";
import { ReactComponent as BoltIcon } from "assets/icons/bolt.svg";
import { ReactComponent as FireIcon } from "assets/icons/fire.svg";
import LevelDetail from "./LevelDetail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPlay } from "@fortawesome/free-solid-svg-icons";
import { m } from "framer-motion";
import { checkIfPartsAreValid } from ".";

const partTranslations = {
  chapter: "Fəsillər",
  heading: "Başlıqlar",
  subheading: "Alt başlıqlar",
};

function mapParts(parts) {
  if (parts == null) {
    return "Fəsillər";
  }

  if (!checkIfPartsAreValid(parts)) {
    return <span className=" text-red-400">Bölmə seçilməyib</span>;
  }

  return Object.keys(parts)
    .filter((part) => parts[part] && part !== "id")
    .map((part) => partTranslations[part])
    .join(", ");
}

export default function LevelsListItem({ level = {}, ...props }) {
  const isDisabled = !checkIfPartsAreValid(level.parts);

  return (
    <div
      {...props}
      style={{
        pointerEvents: isDisabled ? "none" : "auto",
        userSelect: isDisabled ? "none" : "auto",
      }}
      className="custom-focus relative group/level flex-grow outline-violet-900 h-full bg-violet-600  rounded p-3 cursor-pointer"
    >
      <div className="absolute inset-0 opacity-0 transition-all duration-200 bg-transparent group-hover/level:opacity-100 group-hover/level:bg-black/20 flex justify-center items-center">
        <FontAwesomeIcon icon={faPlay} className="me-2" />
        Başla
      </div>
      <h3 className="text-xl mb-2 font-medium leading-6">
        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
        {level.name}
      </h3>
      <ul className="flex lg:block justify-between gap-2 flex-wrap">
        <LevelDetail
          id={level.globalTime}
          Icon={ClockIcon}
          iconClassName="stroke-cyan-300"
          label={`${level.globalTime} saniyə`}
        />
        <LevelDetail
          id={level.health}
          Icon={BoltIcon}
          iconClassName="stroke-red-300"
          label={`${level.health} cəhd`}
        />
        <LevelDetail
          id={
            level.parts == null ||
            level.parts?.chapters == null ||
            level.parts?.chapter
          }
          Icon={FireIcon}
          iconClassName="stroke-orange-300"
          label={mapParts(level.parts)}
        />
      </ul>
    </div>
  );
}
